module.exports = __webpack_public_path__ + "static/media/background.d6e642f6.jpg";